import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  class: "pop_up",
  style: {"display":"block"}
}
const _hoisted_2 = { class: "pop_tit _flex _bb" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "sign_form agree_form" }
const _hoisted_6 = { class: "_flex _center btn_wrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "pop_up_layer",
      style: {"display":"block"},
      onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        ($setup.props.gubun == 1)
          ? (_openBlock(), _createElementBlock("p", _hoisted_3, "개인정보 처리 방침"))
          : (_openBlock(), _createElementBlock("p", _hoisted_4, "서비스 이용약관 수정")),
        _createElementVNode("button", {
          class: "close_btn icon_wrap",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
        }, [...(_cache[4] || (_cache[4] = [
          _createElementVNode("img", {
            src: "img/close.png",
            alt: "닫기"
          }, null, -1)
        ]))])
      ]),
      _createElementVNode("div", _hoisted_5, [
        _cache[5] || (_cache[5] = _createElementVNode("textarea", {
          id: "editor1",
          name: "editor1"
        }, null, -1)),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("button", {
            class: "submit_btn _130 _gray",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
          }, "취소"),
          _createElementVNode("button", {
            class: "submit_btn _130 _main_blue",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args)))
          }, "수정")
        ])
      ])
    ])
  ], 64))
}